import { useEffect } from 'react';
import { App } from 'antd';
import { useNavigate } from 'react-router-dom';

export const useApiSuccessNotification = (
    isSuccess: boolean,
    data: {
        message?: string;
        description?: string;
    },
    backRoute?: string,
    goBack?: boolean
) => {
    const { notification } = App.useApp();
    const navigate = useNavigate();

    useEffect(() => {
        if (data?.message && isSuccess) {
            notification.success({
                message: data?.message ?? 'Успешно сохранено',
                description: data?.description || '',
            });

            if (typeof backRoute === 'string') {
                navigate(backRoute);
            } else if (goBack === true) {
                navigate(-1);
            }
        }
    }, [isSuccess, data, notification, backRoute, goBack]);
};
